<div>
  <div class="icon">
    <mat-icon>schedule</mat-icon>
  </div>

  <div class="description">
    <strong [ngSwitch]="activity.meta.action">
      <span *ngSwitchCase="'message'">Message</span>
      <span *ngSwitchCase="'call'">Call Back</span>
      <span *ngSwitchCase="'todo'">To Do</span>
      Reminder
      <span *ngIf="activity.meta.occurred">Successful</span>
    </strong>

    <span *ngIf="activity.meta.reason">"{{ activity.meta.reason }}"</span>
  </div>
</div>
